<template>
  <div class="flexbox gap-10 no-wrap justify-right">
    <select class="custom-select" v-model="maxRows">
      <option v-for="item in rows" :key="item" :value="item"> {{ item }}</option>
    </select>
    <button type="button" class="btn btn-primary" :disabled="disabledPrev" @click="handlePrev()">
      <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
    </button>
    <select v-if="totalPage > 0" class="custom-select" v-model="page" @change="handleUpdateCurrentPage()">
      <option v-for="item in totalPage" :key="item" :value="item"> {{ item }}/{{ totalPage }}</option>
    </select>
    <select v-else class="custom-select" disabled>
      <option>0/0</option>
    </select>
    <button type="button" class="btn btn-primary" :disabled="disabledNext" @click="handleNext()">
      <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>

export default {
  data () {
    return {
      rows: [50, 100, 200, 300, 500, 1000],
      page: this.currentPage,
      disabledPrev: true,
      disabledNext: false
    }
  },
  computed: {
    maxRows: {
      get () {
        return this.$store.getters.getPaginationRow(this.paginationStorageKey)
      },
      set (val) {
        this.$store.dispatch('updatePaginationRow', { screen: this.paginationStorageKey, row: val })
      }
    }
  },
  props: {
    totalPage: {
      type: Number,
      default: 5
    },
    currentPage: {
      type: Number,
      default: 1
    },
    paginationStorageKey: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.enablePaginateBtn()
  },
  methods: {
    scrollTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    enablePaginateBtn () {
      this.disabledPrev = this.page <= 1
      this.disabledNext = this.page >= this.totalPage
    },
    handlePrev () {
      this.enablePaginateBtn()
      if (this.disabledPrev) {
        return false
      }
      this.page--
      this.handleUpdateCurrentPage()
    },
    handleNext () {
      this.enablePaginateBtn()
      if (this.disabledNext) {
        return false
      }
      this.page++

      this.handleUpdateCurrentPage()
    },
    handleUpdateCurrentPage () {
      this.enablePaginateBtn()
      this.scrollTop()
      this.$emit('updateCurrentPage', this.page)
    }
  },
  watch: {
    currentPage () {
      this.page = this.currentPage
      this.enablePaginateBtn()
    },
    totalPage () {
      this.enablePaginateBtn()
    }
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
.custom-select {
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
       -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
          transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.no-wrap {
  flex-wrap: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/PaginationNextPage.vue